import { FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import { FormattedMessage } from 'dibs-react-intl';
import CreditCardIcon from 'dibs-icons/exports/legacy/CreditCard';
import CreditCardForm from 'dibs-credit-card-form';
import { PaymentMethodSelectOption } from '../PaymentMethodSelectOption';
import {
    usePaymentMethodSelectContext,
    type CreditCardForm as CreditCardFormType,
} from '../PaymentMethodSelectContext';

type CreditCardField = keyof CreditCardFormType;

export const CreditCardPaymentMethod: FC = () => {
    const {
        selectedPaymentMethod,
        updateSelectedPaymentMethod,
        isBusy,
        paymentMethodOptions,
        creditCardForm,
        updateCreditCardForm,
        creditCardFormErrors,
    } = usePaymentMethodSelectContext();

    const isSelected =
        selectedPaymentMethod?.paymentMethodType === 'CREDIT_CARD' &&
        selectedPaymentMethod?.paymentProcessor === 'BRAINTREE' &&
        !selectedPaymentMethod?.paymentMethodToken;

    function handleSelect(): void {
        updateSelectedPaymentMethod({
            paymentMethodType: 'CREDIT_CARD',
            paymentProcessor: 'BRAINTREE',
        });
        updateCreditCardForm({ isVerifying: false });
    }

    function handleChange(payload: { field: CreditCardField; value: string }): void {
        const { field, value } = payload;
        updateCreditCardForm({ [field]: value });
    }

    const hasFormErrors = Object.keys(creditCardFormErrors).length > 0;

    return (
        <PaymentMethodSelectOption
            isChecked={isSelected}
            onChange={handleSelect}
            dataTn="payment-method-creditCard-input"
            name="payment-method"
            value="CREDIT_CARD-BRAINTREE"
            icon={<CreditCardIcon className={dibsCss.block} />}
            label={
                <div className={cn(dibsCss.flexGrow, dibsCss.sassyFontBodyMediumHeavy)}>
                    <FormattedMessage
                        id="dibs-payment.CrediCardPaymentMethod.title"
                        defaultMessage="Credit Card"
                    />
                </div>
            }
            content={
                isSelected ? (
                    <div className={dibsCss.mtSmall}>
                        <CreditCardForm
                            creditCard={creditCardForm}
                            hideSubmit
                            disableForm={isBusy}
                            showAllErrors={hasFormErrors}
                            renderChildren={
                                paymentMethodOptions?.CREDIT_CARD?.additionalFormContent
                            }
                            onUpdate={handleChange}
                            fullWidth
                        />
                    </div>
                ) : null
            }
        />
    );
};
